import { LatLongIcon } from '@rsos/assets/icons';
import ConditionalFeatureDisplay from '../../../Common/ConditionalFeatureDisplay/ConditionalFeatureDisplay';
import { useChatContext } from '../ChatContext';
import { IconButton } from './IconButton';

export const TranslationMenuButton = () => {
  const { isTranslationMenuOpen, openTranslationMenu } = useChatContext();

  return (
    <ConditionalFeatureDisplay
      dataName="chat-translation-menu-button"
      conditions={[{ featureFlagEnabled: 'text-manual-translation-override' }]}
    >
      <IconButton
        title="Translation menu"
        active={isTranslationMenuOpen}
        onClick={() => openTranslationMenu(!isTranslationMenuOpen)}
      >
        <LatLongIcon width={14} height={14} color="secondaryText" />
      </IconButton>
    </ConditionalFeatureDisplay>
  );
};
